import React, { Component } from "react"
import Img from 'gatsby-image'

class Hero extends Component {
  render() {

    let house = this.props.house

    return(
      <div className="house-hero">
        <div className="house-home__wrapper" />
        <Img
          key={ house.image.id }
          sizes={ house.image.sizes }
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            zIndex: 1
          }}
        />
        <div className="house-hero__body">
          <div className="house-hero__title">
            <h1>{ house.name }</h1>
          </div>
          <div className="house-hero__address">
            { house.address }
          </div>
          <div
            className="house-hero__tagline"
            dangerouslySetInnerHTML={{
              __html: house.tagLine
            }}
          />
        </div>
      </div>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero/index.js